import { ILowRateMortgage } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectLowRateMortgage = (state: IApplicationState): ILowRateMortgage => {
  return state.promosPage.lowRateMortgage;
};
